export default "__VITE_ASSET__KzURqS5D__"